import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont } from '../../../theme';

export const useQuoteDeliveryStatusStyles = createStyles(({ token }) => ({
  itineraryStatus: {
    color: ThemeColors.COLOR_BLUE3,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontSize: token.fontSizeSM,
    fontWeight: 700,
    textTransform: 'uppercase',
    marginLeft: token.marginXXS,
  },
  itineraryLabel: {
    color: ThemeColors.COLOR_GREY_BLUISH,
    fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
    fontWeight: 500,
    letterSpacing: 0,
    textTransform: 'uppercase',

    [`@media (max-width: ${token.screenXLMax}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_XS,
    },
    [`@media (max-width: ${token.screenSMMax}px)`]: {
      fontWeight: 400,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      fontFamily: token.fontFamily,
    },
  },
  itineraryLabelBold: {
    color: ThemeColors.COLOR_GREY_BLUISH,
    letterSpacing: 0,
    textTransform: 'uppercase',
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontSize: token.fontSizeSM,
    fontWeight: 700,
    height: 22,

    [`@media (max-width: ${token.screenXLMax}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_XS,
    },
    [`@media (max-width: ${token.screenMDMax}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
    },
    [`@media (max-width: ${token.screenSMMax}px)`]: {
      fontWeight: 400,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      fontFamily: token.fontFamily,
      height: 'auto',
    },
  },
}));
